import { createRequestActionTypes, createActionType } from '../../helpers'

export const FETCH_GUIDES = createRequestActionTypes('GUIDES', 'GUIDES')
export const SET_ACTIVE_GUIDE = createActionType('GUIDES', 'SET_ACTIVE_GUIDE')



// WEBPACK FOOTER //
// ./src/containers/Guides/constants.js